export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13998.afa0c2d0.jpg";